import 'common/views/atoms/Pagination/NavRow.scss'
import React from 'react'
import PropTypes from 'prop-types'

const CountTag = ({count, pageNumber, isLoading}) => {
  const pageSize = 25;
  const pageCount = Math.ceil(count / pageSize)
  const lastPage = pageCount === pageNumber
  const firstIndex = count > 0 ? ((pageNumber - 1) * pageSize) + 1: 0
  const lastIndex = count > 0 ? lastPage ? count : firstIndex + (pageSize - 1) : 0
  if (count > 0) {
     <span>&nbsp;&nbsp; {firstIndex} - {lastIndex} of {count} items</span>
  }

  if ((!count || count === 0) && isLoading) {
    return <span>&nbsp;&nbsp;</span>
  }

  return <span>&nbsp;&nbsp; {count} items</span>
}

const InfinitePages = ({ forward, back, count, pageNumber, onPageForward, onPageBackward, isLoading}) => {

  return (
    <div className="NavRow__nav-row">
      <div className="-pages">
        { back && <i className="fa fa-angle-left -backward" onClick={onPageBackward} />}
        <CountTag count={count} pageNumber={pageNumber} isLoading={isLoading} />
        { forward &&  <i className="fa fa-angle-right -forward"  onClick={onPageForward} />}
      </div>
    </div>
  )
}

InfinitePages.propTypes = {
  onPageForward: PropTypes.func.isRequired,             // () => {}
  onPageBackward: PropTypes.func.isRequired,            // () => {}
  disabled: PropTypes.bool,                             // Used to prevent click spam when requests are in-flight, for instance
}

export default InfinitePages
